import { render, staticRenderFns } from "./base-error-message.vue?vue&type=template&id=1bc0c2c4&scoped=true"
import script from "./base-error-message.vue?vue&type=script&lang=js"
export * from "./base-error-message.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bc0c2c4",
  null
  
)

export default component.exports